import { css } from '@emotion/react'
import { memo } from 'react'

export const NotificationActiveIcon = memo(() => (
	<svg
		width="28"
		height="29"
		viewBox="0 0 28 29"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		css={css`
			display: block;
		`}
	>
		<path
			d="M24.15 14.4849C24.1541 16.0559 23.7871 17.6057 23.0788 19.008C22.2389 20.6885 20.9478 22.1019 19.35 23.09C17.7523 24.078 15.911 24.6018 14.0324 24.6025C12.4613 24.6066 10.9115 24.2395 9.50921 23.5312L3.7334 25.1139L4.98603 19.008C4.27772 17.6057 3.91066 16.0559 3.91475 14.4849C3.91548 12.6063 4.43922 10.765 5.4273 9.16721C6.41539 7.56945 7.8288 6.27835 9.50921 5.4385C10.9115 4.73018 12.4613 4.36313 14.0324 4.36722H14.6275C17.1086 4.5041 19.4519 5.5513 21.2089 7.30831C22.966 9.06533 24.0132 11.4087 24.15 13.8897V14.4849Z"
			stroke="currentColor"
			strokeWidth="2.1"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<circle cx="23" cy="5.86719" r="4" fill="#FFD001" stroke="white" strokeWidth="2" />
	</svg>
))
